var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { View, Property, layoutConfig, ScaleType, Resource } from "doric";
export class SVG extends View {
    set innerElement(e) {
        this.rawString = e;
    }
}
__decorate([
    Property,
    __metadata("design:type", String)
], SVG.prototype, "url", void 0);
__decorate([
    Property,
    __metadata("design:type", String)
], SVG.prototype, "rawString", void 0);
__decorate([
    Property,
    __metadata("design:type", Resource)
], SVG.prototype, "localResource", void 0);
__decorate([
    Property,
    __metadata("design:type", Number)
], SVG.prototype, "scaleType", void 0);
__decorate([
    Property,
    __metadata("design:type", Function)
], SVG.prototype, "loadCallback", void 0);
export function svg(config) {
    const ret = new SVG;
    ret.layoutConfig = layoutConfig().fit();
    ret.scaleType = ScaleType.ScaleAspectFit;
    if (config) {
        ret.apply(config);
    }
    return ret;
}
//# sourceMappingURL=SVG.js.map